<template>
  <div class="portal-shell" :class="{ 'portal-shell--home': isHome }">
    <portal-header
      :is-home="isHome"
      :nav-items="navItems"
      :session="session"
      @logout="handleLogout"
    />
    <main class="portal-main" :class="{ 'portal-main--home': isHome }">
      <div class="portal-main__inner">
        <router-view />
      </div>
    </main>
    <portal-footer :is-home="isHome" />
  </div>
</template>

<script>
import PortalHeader from '@/components/PortalHeader.vue'
import PortalFooter from '@/components/PortalFooter.vue'
import { clearSession, getAuthEventName, getSession } from '@/utils/auth'

export default {
  name: 'PortalLayout',
  components: {
    PortalHeader,
    PortalFooter
  },
  data() {
    return {
      session: null
    }
  },
  computed: {
    isHome() {
      return this.$route && this.$route.path === '/'
    },
    navItems() {
      return [
        { label: '首页', to: '/' },
        { label: '成绩列表', to: '/scores' },
        { label: '证书直查', to: '/certificate/ZY20260001' }
      ]
    }
  },
  created() {
    this.syncSession()
  },
  mounted() {
    window.addEventListener(getAuthEventName(), this.syncSession)
  },
  beforeDestroy() {
    window.removeEventListener(getAuthEventName(), this.syncSession)
  },
  methods: {
    syncSession() {
      this.session = getSession()
    },
    handleLogout() {
      clearSession()
      if (this.$route.path !== '/') {
        this.$router.push('/')
      } else {
        this.syncSession()
      }
    }
  }
}
</script>
